import { render } from "./doctor-register-step2.vue?vue&type=template&id=4f377892"
import script from "./doctor-register-step2.vue?vue&type=script&lang=js"
export * from "./doctor-register-step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__